import useListDisplayState from "@hooks/useListDisplayState"

import { useSelectContext } from "@molecules/Select/Select.context"

import { SelectLoadingProps } from "./SelectLoading.types"

export default function SelectLoading(props: SelectLoadingProps) {
    const { children, itemCount: itemCountOverride } = props
    const { searchData } = useSelectContext()

    const isLoading = searchData?.isLoading ?? false
    const isFetching = searchData?.isFetching ?? false
    const isFetchingNextPage = searchData?.isFetchingNextPage ?? false
    const isTyping = searchData?.searchState.isTyping ?? false
    const hasSearchTerm = searchData?.searchState.hasSearchTerm ?? false
    const itemCount = itemCountOverride ?? searchData?.results.length ?? 0

    const { showLoadingState } = useListDisplayState({
        isLoading,
        isFetching,
        isFetchingNextPage,
        isTyping,
        itemCount,
        hasSearchTerm,
    })

    if (!searchData || !showLoadingState || searchData?.isError) {
        return null
    } else {
        return <>{children}</>
    }
}
